import router from './index'
import store from '@/store'
import Vue from 'vue'

router.beforeEach((to, from, next) => {
  // 扫码弹窗打开时，要关闭弹窗， 不路由
  if (Vue.prototype.$globalScanModal && Vue.prototype.$globalScanModal.visible === true) {
    Vue.prototype.$scanModalOptEvent && Vue.prototype.$scanModalOptEvent.dismissGlobalModal()
    next(false)
  } else {
    const token = store.state.authModule.token
    const sharePayload = store.state.publicFormModule.sharePayload
    if (token || sharePayload || (to.query.code && to.query.state === 'STATE') || to.path.startsWith('/account') || to.path.startsWith('/blank') || to.path.startsWith('/error')) {
      next()
    } else {
      next({ path: '/account/login' })
    }
  }
})

router.beforeEach((to, from, next) => {
  window.history.replaceState(null, null, window.location.href)
  window.document.title = to.meta.title === undefined
    ? to.query.title
      ? to.query.title
      : '得帆云'
    : to.meta.title
  if ((to.path === '/' || to.path === '/index.html') && !to.query.code) {
    next({ name: 'account', query: to.query })
  } else {
    next()
  }
})
